import { makeActionCreator } from "../../utils";
import { apiFetch } from "../../actions/apiActions";
import { toast } from "react-toastify";

export const FILE_ADDED = "USERS.EDIT_USER.FILES.FILE_ADDED";
export const PROGRESS_CHANGED = "USERS.EDIT_USER.FILES.PROGRESS_CHANGED";
export const FILE_ERRORED = "USERS.EDIT_USER.FILES.FILE_ERRORED";
export const REPLACE_FILE_AFTER_UPLOAD = "USERS.EDIT_USER.FILES.REPLACE_FILE_AFTER_UPLOAD";
export const FILE_DELETED = "USERS.EDIT_USER.FILES.FILE_DELETED";

export const fileAddedUser = makeActionCreator(FILE_ADDED, "payload");
export const progressChanged = makeActionCreator(PROGRESS_CHANGED, "fileId", "payload");
export const fileErrored = makeActionCreator(FILE_ERRORED, "fileId", "payload");
export const replaceFileAfterUploadUser = makeActionCreator(REPLACE_FILE_AFTER_UPLOAD, "fileId", "payload");
export const fileDeletedUser = makeActionCreator(FILE_DELETED, "fileId");

export function startFileUpload(input) {
    return async (dispatch, getState) => {
        try {
            if (!input || !input.files[0]) return;
            var data = new FormData();
            data.append("file", input.files[0]);
            const totalSize = input.files[0].size;

            const tempId = Math.random().toString(36);
            dispatch(
                fileAddedUser({
                    _id: tempId, // assign a temporary id before it is uploaded
                    uploading: true,
                    error: null,
                    originalName: input.files[0].name,
                    progress: 0
                })
            );
            let resp = await dispatch(
                apiFetch("/api/files/upload", {
                    method: "POST",
                    fileUpload: true,
                    body: data
                })
            );
            const jsonData = await resp.json();
            if (!resp.ok) {
                throw new Error(jsonData.message);
            }
            dispatch(
                replaceFileAfterUploadUser(tempId, {
                    uploading: false,
                    error: null,
                    ...jsonData
                })
            );
        } catch (e) {
            toast(e.message, { type: "error" });
            dispatch(fileDeletedUser(tempId));
        }
    };
}



